module.exports = __webpack_public_path__ + "img/jobboardy-select-site.3dd01aff.png";